/**
 * @generated SignedSource<<93a1e53f47615d90e9cc8c687163e013>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_softwareCodePage_ConnectionPage$data = {
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_OneClickConnect" | "main_softwareCodePage_ReadyToConnect">;
  readonly " $fragmentType": "main_softwareCodePage_ConnectionPage";
};
export type main_softwareCodePage_ConnectionPage$key = {
  readonly " $data"?: main_softwareCodePage_ConnectionPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_ConnectionPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_softwareCodePage_ConnectionPage",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_softwareCodePage_ReadyToConnect"
    },
    {
      "kind": "FragmentSpread",
      "name": "main_softwareCodePage_OneClickConnect"
    }
  ],
  "type": "Query"
};

(node as any).hash = "83ae27900b5eee2efd5f271a9082c3cd";

export default node;
